import axiosInstance from "../../api/axiosInstance";
import { useSnackbar } from "../../Providers/SnackbarProvider";
import { xorDecrypt } from "../../encrypt";

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const handleSubmit = async (
  event,
  values,
  openSnackbar,
  setResponseData,
  setResponseDialogOpen,
  setLoading // Add setLoading as a parameter
) => {
  if (event && event.preventDefault) event.preventDefault();

  const updatedValues = { ...values };
  //console.log("Payload before submission:", values);
  //console.log(updatedValues);
  delete updatedValues["undefined"];

  const handleOtherField = (field) => {
    const otherField = `other${capitalizeFirstLetter(field)}`;
    if (
      updatedValues[field] &&
      updatedValues[field].includes("Other") &&
      updatedValues[otherField]
    ) {
      updatedValues[field] = updatedValues[field].filter(
        (item) => item !== "Other"
      );
      updatedValues[field].push(updatedValues[otherField] || "");
    }
  };

  handleOtherField("placeOfServiceCode");
  handleOtherField("sessionParticipants");
  handleOtherField("primaryTargetAreasAddressed");
  handleOtherField("behaviorInterventions");
  handleOtherField("malAdaptiveBehaviors");
  handleOtherField("reinforcers");
  handleOtherField("skillStrategies");
  handleOtherField("clientMoodAndResponse");
  handleOtherField("sessionStartGreetings");
  handleOtherField("sessionEndComments");
  handleOtherField("nextSessionPlans");

  if (Array.isArray(updatedValues.reinforcerUsedDuringSession)) {
    updatedValues.reinforcerUsedDuringSession =
      updatedValues.reinforcerUsedDuringSession.join(", ");
  }

  //console.log("Cleaned values before submission:", updatedValues);

  // openSnackbar("Please Wait, the response is being generated", "info");
  setLoading(true); // Set loading to true

  try {
    const token = xorDecrypt(localStorage.getItem("ABAtoken"));
    //console.log("Decrypted token:", token); // Log the decrypted token
    if (!token) {
      throw new Error("Token is missing or invalid");
    }
    axiosInstance
      .post(
        "/abanotes/sessionnotes" + updatedValues.procedureCode,
        {
          ...updatedValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          openSnackbar("Response Generated ", "success");
          setResponseData(response.data[0].message);
          if (setResponseDialogOpen) setResponseDialogOpen(true);
          //console.log(response.data[0].message);
        } else {
          openSnackbar("Failed to generate session notes, please try again", "error");
        }
      })
      .catch((err) => {
        //console.log("Error response:", err.response); // Log the error response
        //console.log("Error data:", err.response.data); // Log the error data
        //console.log("Error status:", err.response.status); // Log the error status
        //console.log("Error headers:", err.response.headers); // Log the error headers
        openSnackbar("Failed to generate session notes, please try again", "error");
      })
      .finally(() => {
        setLoading(false); // Set loading to false
      });

  } catch (error) {
    //console.log("Error:", error); // Log the error
    openSnackbar("Failed to generate session notes, please try again", "error");
    setLoading(false); // Set loading to false
  }
};